import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import logo from "./logo.png";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";



function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (location.pathname === "/get-approved") {
  return null;
}

  const getLinkClass = (path) =>
    location.pathname === path
      ? "text-teal-400 font-semibold border-b-2 border-teal-400 pb-1"
      : "hover:text-teal-400 transition";
   
      



  return (
    <header className="bg-[#0A2540] text-white shadow-lg sticky top-0 z-50">

      {/* 🔹 TOP BAR — Hidden on Mobile */}
      <div className="hidden md:flex justify-between items-center px-8 py-2 text-sm border-b border-teal-600/40">
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1">
            <MdEmail /> yesautofinance1@gmail.com
          </span>
          <span className="flex items-center gap-1">
            <MdPhone /> +1 (587) 920-6970
          </span>
        </div>

        <div className="flex items-center gap-4 text-lg">
          <FaFacebook className="hover:text-teal-400 transition" />
          <FaInstagram className="hover:text-teal-400 transition" />
          <FaLinkedin className="hover:text-teal-400 transition" />
          <FaYoutube className="hover:text-teal-400 transition" />
        </div>
      </div>

      {/* 🔹 MAIN NAVBAR */}
      <nav className="flex justify-between items-center px-6 py-4 md:px-10">
        
        {/* LOGO */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-3"
        >
          <img src={logo} alt="Yes Auto" className="w-12 h-12 rounded-full" />
          <h1 className="text-3xl font-extrabold bg-gradient-to-r from-teal-400 via-cyan-300 to-white bg-clip-text text-transparent">
            YES AUTO
          </h1>
        </motion.div>

        {/* HAMBURGER FOR MOBILE */}
        <div className="md:hidden">
          <button onClick={() => setMobileOpen(!mobileOpen)}>
            <span className="text-3xl">☰</span>
          </button>
        </div>

        {/* DESKTOP MENU */}
        <motion.ul
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="hidden md:flex gap-8 text-md font-medium"
        >
          <li><Link to="/" className={getLinkClass("/")}>Home</Link></li>
          <li><Link to="/about" className={getLinkClass("/about")}>About</Link></li>
          <li><Link to="/faq" className={getLinkClass("/faq")}>FAQ</Link></li>
          <li><Link to="/contact" className={getLinkClass("/contact")}>Contact</Link></li>
          <li><Link to="/services" className={getLinkClass("/services")}>Services</Link></li>
          <li><Link to="/blog" className={getLinkClass("/blog")}>Blog</Link></li>

          {/* UPDATED ITEMS */}
          <li><Link to="/loan-calculator" className={getLinkClass("/loan-calculator")}>Loan Calculator</Link></li>
          <li><Link to="/terms" className={getLinkClass("/terms")}>Terms</Link></li>
          <li><Link to="/eligibility" className={getLinkClass("/eligibility")}>Eligibility</Link></li>
        </motion.ul>
      </nav>

      {/* 🔹 MOBILE MENU DROPDOWN */}
      {mobileOpen && (
        <div className="md:hidden bg-[#0A2540] border-t border-teal-600/40 px-6 pb-6">
          <ul className="flex flex-col gap-4 text-lg pt-4">

            <li><Link to="/" className={getLinkClass("/")}>Home</Link></li>
            <li><Link to="/about" className={getLinkClass("/about")}>About</Link></li>
            <li><Link to="/faq" className={getLinkClass("/faq")}>FAQ</Link></li>
            <li><Link to="/contact" className={getLinkClass("/contact")}>Contact</Link></li>
            <li><Link to="/services" className={getLinkClass("/services")}>Services</Link></li>
            <li><Link to="/blog" className={getLinkClass("/blog")}>Blog</Link></li>

            {/* UPDATED ITEMS */}
            <li><Link to="/loan-calculator" className={getLinkClass("/loan-calculator")}>Loan Calculator</Link></li>
            <li><Link to="/terms" className={getLinkClass("/terms")}>Terms</Link></li>
            <li><Link to="/eligibility" className={getLinkClass("/eligibility")}>Eligibility</Link></li>

          </ul>
        </div>
      )}
    </header>
  );
}

export default Navbar;
